export function computeExploreUnknownDarknessLossFillFromPct(runDarknessPercent, memoryDarknessReductionTotal) {
  if (typeof runDarknessPercent !== 'number' || Number.isNaN(runDarknessPercent)) {
    throw new Error(
      'computeExploreUnknownDarknessLossFillFromPct: runDarknessPercent must be a finite number'
    );
  }
  if (
    typeof memoryDarknessReductionTotal !== 'number' ||
    Number.isNaN(memoryDarknessReductionTotal)
  ) {
    throw new Error(
      'computeExploreUnknownDarknessLossFillFromPct: memoryDarknessReductionTotal must be a finite number'
    );
  }

  const fromPct = Math.max(0, Math.min(100, runDarknessPercent - memoryDarknessReductionTotal));
  return fromPct;
}
